import React, { createContext, useContext, useState, useCallback } from "react";
import { useSelector } from "react-redux";
import { isEqual, isFunction } from "lodash";
import { initialFilter } from "./PersonnelReportUIHelpers";

const PersonnelReportUIContext = createContext();

export function usePersonnelReportUIContext() {
  return useContext(PersonnelReportUIContext);
}

export const PersonnelReportUIConsumer = PersonnelReportUIContext.Consumer;

export function PersonnelReportUIProvider({ children }) {
  const { user } = useSelector(state => state.auth);
  initialFilter.term = user.currentActiveTerm; // Mevcut Aktif Dönem Atanıyor
  const [queryParams, setQueryParamsBase] = useState(initialFilter);
  const setQueryParams = useCallback((nextQueryParams) => {
    setQueryParamsBase((prevQueryParams) => {
      if (isFunction(nextQueryParams)) {
        nextQueryParams = nextQueryParams(prevQueryParams);
      }

      if (isEqual(prevQueryParams, nextQueryParams)) {
        return prevQueryParams;
      }

      return nextQueryParams;
    });
  }, []);
  
  const value = {
    queryParams,
    setQueryParamsBase,
    setQueryParams
  };

  return (
    <PersonnelReportUIContext.Provider value={value}>
      {children}
    </PersonnelReportUIContext.Provider>
  );
}